module.exports = require("moment/locale/fr");